import CustomTextButton from './custom-text-button';

export default CustomTextButton;
